import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography, Box } from '@mui/material';
var AvailabilityCalendar = function () {
    return (_jsxs(Box, { children: [_jsx(Typography, { variant: "h4", children: "Availability Calendar" }), _jsx(Typography, { children: "Manage room availability across dates" })] }));
};
export default AvailabilityCalendar;
